import Model from 'models/Model';
import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import ProductEnhancementDocument from 'models/productManagement/productEnhancementDocument/ProductEnhancementDocument';
import DealerGroup from '../dealerGroup/Model.DealerGroup';
import { Language } from 'assets/locales/Locale';

export default class ProductEnhancementDealerGroupDocument
  extends Model<Model.IProductEnhancementDealerGroupDocument>({ icon: 'if-login' })
  implements Model.Instance<Model.IProductEnhancementDealerGroupDocument>
{
  id: number;
  productEnhancementDocumentId: number;
  productEnhancementDocument?: ProductEnhancementDocument;
  dealerGroupId: number;
  dealerGroup?: DealerGroup;
  mediaFileId: number;
  mediaFile: MediaFile;
  languageIsoCode?: Locale.Languages = Language.english;

  constructor(
    data:
      | Partial<Model.IProductEnhancementDealerGroupDocument>
      | Utils.FormData<Model.IProductEnhancementDealerGroupDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        mediaFile: MediaFile,
        productEnhancementDocument: ProductEnhancementDocument,
        dealerGroup: DealerGroup,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.mediaFile?.name || this.id?.toString(),
    };
  }
}
